import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/calendar.svg'


const _withScopeId = n => (_pushScopeId("data-v-e878ba20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "calendar-input-wrapper" }
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "~", -1 /* HOISTED */))
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  "aria-hidden": "true",
  alt: ""
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "calendar-input",
        type: "button",
        "aria-label": "시작일 달력 열기",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickFromDate')))
      }, [
        _createElementVNode("input", {
          class: "from-date",
          type: "text",
          value: $setup.dayjs($props.fromDate).format($props.dateFormat),
          readonly: "",
          "aria-hidden": "true"
        }, null, 8 /* PROPS */, _hoisted_3),
        _hoisted_4
      ]),
      _hoisted_5,
      _createElementVNode("button", {
        class: "calendar-input",
        type: "button",
        "aria-label": "종료일 달력 열기",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onClickToDate')))
      }, [
        _createElementVNode("input", {
          class: "to-date",
          type: "text",
          value: $setup.dayjs($props.toDate).format($props.dateFormat),
          readonly: "",
          "aria-hidden": "true"
        }, null, 8 /* PROPS */, _hoisted_6),
        _hoisted_7
      ])
    ])
  ]))
}